// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPublicationCard-cls1_LaX","cls2":"EvaluationPublicationCard-cls2_WCR EvaluationPublicationCard-cls1_LaX"};